import { combineReducers } from '@reduxjs/toolkit';
import { reducer as setListReducer } from './services/set-list';
import { reducer as publishSetReducer } from './services/publish-set';

export default combineReducers({
  list: setListReducer,
  publish: publishSetReducer,
});
